import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { street, cityAndZip } from 'shared/models/address';
import { setAddress } from 'components/address/actions';
import AddressInput from './addressInput';
import Dropdown from 'components/ui/dropdown';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import AddressEntryBg from 'images/address-entry-bg.jpg';

class HeaderAddress extends React.Component {
  render() {
    const displayAddress = street(this.props) || cityAndZip(this.props);

    return (
      <Dropdown className="header-address-container">
        {({ isOpen, triggerRef, contentRef, forceClose }) => (
          <Fragment>
            <a className="clickable header-address" ref={triggerRef}>
              <div className="header-address-display">
                <span className="header-address-title">
                  Deliver ASAP <span>To</span>
                </span>
                {displayAddress && (
                  <span className="header-address-desc">{displayAddress}</span>
                )}
                {!displayAddress && (
                  <span className="header-address-desc">
                    Enter a Delivery Address
                  </span>
                )}
              </div>
              <div className="header-address-icon">
                <i className="icon-down-arrow" />
              </div>
            </a>
            {isOpen && (
              <div className="header-address-content" ref={contentRef}>
                <View padding={{ top: 'sm', bottom: 'sm' }}>
                  <Text tag="span" title weight="med" className="input-label">
                    <i className="fa fa-location-arrow" /> Enter Your Delivery
                    Address
                  </Text>
                </View>
                <AddressInput
                  setAddress={address => {
                    this.props.setAddress(address, this.props.trackingParams);
                    forceClose();
                  }}
                  defaultValue={displayAddress}
                />
                <img className="address-entry-bg" src={AddressEntryBg} />
              </div>
            )}
          </Fragment>
        )}
      </Dropdown>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.address };
}

export default connect(mapStateToProps, { setAddress })(HeaderAddress);



// WEBPACK FOOTER //
// ./shared/components/header/address.js